"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoComplete = AutoComplete;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fuse = _interopRequireDefault(require("fuse.js"));

var _deburr = _interopRequireDefault(require("lodash/deburr"));

var _downshift = _interopRequireDefault(require("downshift"));

var _material = require("@mui/material");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var getFuzzySuggestions = function getFuzzySuggestions(searchValue, items, keyName, fuseThreshold) {
  var normalizedSearchValue = (0, _deburr["default"])(searchValue.trim()).toLowerCase();
  var fuseOptions = {
    shouldSort: true,
    threshold: fuseThreshold,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: [keyName]
  };
  var fuse = new _fuse["default"](items, fuseOptions);
  var results = fuse.search(normalizedSearchValue);
  var foundItems = results.map(function (result) {
    return result.item;
  });
  return foundItems;
};

function AutoComplete(_ref) {
  var onSelect = _ref.onSelect,
      options = _ref.options,
      DownshiftProps = _ref.DownshiftProps,
      TextFieldProps = _ref.TextFieldProps,
      MenuItemProps = _ref.MenuItemProps,
      _ref$showAllOnEmptyIn = _ref.showAllOnEmptyInput,
      showAllOnEmptyInput = _ref$showAllOnEmptyIn === void 0 ? true : _ref$showAllOnEmptyIn,
      _ref$numOfDropdownIte = _ref.numOfDropdownItems,
      numOfDropdownItems = _ref$numOfDropdownIte === void 0 ? 10 : _ref$numOfDropdownIte,
      _ref$fuseThreshold = _ref.fuseThreshold,
      fuseThreshold = _ref$fuseThreshold === void 0 ? 0.6 : _ref$fuseThreshold;
  return /*#__PURE__*/_react["default"].createElement(_downshift["default"], _extends({
    onSelect: onSelect,
    itemToString: function itemToString(item) {
      return item ? item.display : '';
    }
  }, DownshiftProps), function (_ref2) {
    var inputValue = _ref2.inputValue,
        isOpen = _ref2.isOpen,
        getInputProps = _ref2.getInputProps,
        getItemProps = _ref2.getItemProps,
        getMenuProps = _ref2.getMenuProps,
        highlightedIndex = _ref2.highlightedIndex,
        closeMenu = _ref2.closeMenu,
        openMenu = _ref2.openMenu;
    var fuzzySuggestions = showAllOnEmptyInput && !inputValue ? options.sort(function (optA, optB) {
      var comparison = 0;

      if (optA.key > optB.key) {
        comparison = 1;
      } else if (optA.key < optB.key) {
        comparison = -1;
      }

      return comparison;
    }) : getFuzzySuggestions(inputValue, options, 'display', fuseThreshold);
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_material.TextField, _extends({
      fullWidth: true,
      inputProps: {
        onFocus: function onFocus() {
          return openMenu();
        },
        onBlur: function onBlur() {
          return closeMenu();
        }
      }
    }, TextFieldProps, getInputProps())), /*#__PURE__*/_react["default"].createElement("div", _extends({
      style: {
        position: 'relative'
      }
    }, getMenuProps()), isOpen && /*#__PURE__*/_react["default"].createElement(_material.Paper, {
      elevation: 2,
      style: {
        position: 'absolute',
        zIndex: 1,
        left: 0,
        right: 0
      }
    }, fuzzySuggestions.slice(0, numOfDropdownItems ? numOfDropdownItems : fuzzySuggestions.length).map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, _extends({
        key: item.value
      }, MenuItemProps, item.props, getItemProps({
        index: index,
        item: item,
        selected: highlightedIndex === index
      })), item.display);
    }))));
  });
}

AutoComplete.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
    display: _propTypes["default"].string.isRequired,
    props: _propTypes["default"].object
  })).isRequired,
  onSelect: _propTypes["default"].func.isRequired,
  DownshiftProps: _propTypes["default"].object,
  TextFieldProps: _propTypes["default"].object,
  MenuItemProps: _propTypes["default"].object,
  showAllOnEmptyInput: _propTypes["default"].bool,
  numOfDropdownItems: _propTypes["default"].number,
  fuseThreshold: _propTypes["default"].number
};
var _default = AutoComplete;
exports["default"] = _default;